import React from 'react';
import { CompanyIcon, StoreIcon } from '../../../../theme/icons';
import { Group } from '../../../../../../redux/groups/api/group.model';
import { getPolyglot } from '../../../../../../i18n';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../../../../../redux/store.model';
import { getAlarmActiveBySelector } from '../../../../../../redux/incident/selectors/getAlarmActiveBySelector';
import { BusinessRole } from '../../../../redux/businessModel/model/model';
import { GroupType } from '../../../../redux/group/model';
import { useGetChildCount } from '../../../../hooks/useGetChildCount';
import { CardItem } from '../../../../../../theme/components';
import { GroupActionsGrid } from '../../../../../../components/DeviceManager/Group/Overview/GroupsOverview/GroupActions/GroupActions';
import { useTheme } from '@mui/material';

interface GroupCardGridProps {
  group: Group;
  showImage?: boolean;
  moduleSelected: string | '';
}
function FreshwatchGroupCardGrid(props: GroupCardGridProps) {
  const { group, showImage = true } = props;
  const polyglot = getPolyglot();
  const navigate = useNavigate();
  const theme = useTheme();

  const { data: alarmsActive } = useAppSelector((state) =>
    getAlarmActiveBySelector(state, {
      groupId: group.id,
    })
  );

  const onNavigateToMerchandiser = () => {
    if (group?.attributes?.['BUSINESS_ROLE'] === BusinessRole.STORE) {
      navigate(`/merchandiser/${group?.id}`);
    } else {
      navigate(`/companies/group/${group?.id}`);
    }
  };
  const isStorePath =
    group?.attributes && group?.attributes['BUSINESS_ROLE'] === GroupType.Store;

  const childCount = useGetChildCount(group);
  const merchandisers = polyglot.t('freshwatch.store.countMerchandisers', {
    smart_count: childCount.merchandisersCount,
  });
  const stores = polyglot.t('freshwatch.store.countStores', {
    smart_count: childCount.storesCount,
  });

  const subtitle =
    group?.attributes?.BUSINESS_ROLE === GroupType.Store
      ? merchandisers
      : `${stores} - ${merchandisers}`;

  return (
    <CardItem
      key={group.id}
      name={group.name}
      subtitle={subtitle}
      altIcon={polyglot.t('group.icon')}
      iconURL={group?.iconURL ?? undefined}
      defaultIcon={
        isStorePath ? (
          <StoreIcon height={'100px'} color={theme.palette.primary.main} />
        ) : (
          <CompanyIcon height={'100px'} color={theme.palette.primary.main} />
        )
      }
      onClick={onNavigateToMerchandiser}
      error={alarmsActive.length > 0}
      buttonsActions={<GroupActionsGrid group={group} />}
      showImage={showImage}
    />
  );
}

export default FreshwatchGroupCardGrid;
